/*
 * @Description:
 * @Author: 姓名
 * @Date: 2024-12-31 10:04:05
 * @LastEditTime: 2024-12-31 17:18:58
 * @LastEditors: caoran
 */
/* eslint-disable */
// 腾讯云COS上传
import COS from 'cos-js-sdk-v5'
const cos = new COS({
  // 其他配置项可参考下方 初始化配置项
  // getAuthorization 必选参数
  getAuthorization: function (options, callback) {
    // 初始化时不会调用，只有调用 cos 方法（例如 cos.putObject）时才会进入
    // 异步获取临时密钥
    // 服务端 JS 示例：https://github.com/tencentyun/cos-js-sdk-v5/blob/master/server/
    // 服务端其他语言参考 COS STS SDK ：https://github.com/tencentyun/qcloud-cos-sts-sdk
    // STS 详细文档指引看：https://cloud.tencent.com/document/product/436/14048
    // const stsUrl = 'https://webapitest.xhey.top' + '/web/tencent/ststoken' // 自己的后端服务
    const stsUrl = __API_SERVER_HOST__ + '/web/tencent/ststoken'
    fetch(stsUrl, {
      method: 'POST',
      body: JSON.stringify({})
    })
      .then((response) => {
        return response.json()
      })
      .then((data) => {
        if (!data || !data.data) {
          return console.error(
            'credentials invalid:\n' + JSON.stringify(data, null, 2)
          )
        }
        // 检查credentials格式
        const credentials = data.data
        callback({
          TmpSecretId: credentials.secretID,
          TmpSecretKey: credentials.secretKey,
          SecurityToken: credentials.sessionToken,
          // 建议返回服务器时间作为签名的开始时间，避免客户端本地时间偏差过大导致签名错误
          StartTime: Math.floor(Date.now() / 1000), // 时间戳，单位秒
          ExpiredTime: credentials.expiredTime, // 时间戳，单位秒，如：1580000000
          ScopeLimit: true // 细粒度控制权限需要设为 true，会限制密钥只在相同请求时重复使用
        })
      })
      .catch((error) => {
        console.error('获取临时密钥失败', error)
      })
  }
})
export default cos
